import { render } from "./App.vue?vue&type=template&id=76916dec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=76916dec&lang=css"

import exportComponent from "C:\\Users\\hkun\\Downloads\\print_shop-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__